const React = require("react");
const T = React.PropTypes;

require("./SurveyConfirmation.less"); 

const SurveyType = require("~/types/Survey.js").PropType; 
const QuestionValidationStatus = require("~/types/QuestionValidationStatus.js");
const Navigator = require("~/navigator.js");
const auditCompletionDispatchers = require("~/events/auditCompletion/auditCompletionDispatchers.js");

const SurveyConfirmationPage = require("../SurveyConfirmationPage/SurveyConfirmationPage.jsx");
const Error = require("~/types/Error.js").PropType; 

const SurveyConfirmation = React.createClass({
    propTypes: {
        Survey: SurveyType.isRequired,
        EmailRecipients: T.shape({
            Data: T.arrayOf(T.string),
            IsLoading: T.bool.isRequired,
            Error: Error
        })
    }, 
    render () {
        const complete = this.isComplete();

        return (<SurveyConfirmationPage 
                   Survey={this.props.Survey} 
                   EmailRecipients={this.props.EmailRecipients.Data}
                   OnBack={this.BackToSurvey}  
                   OnSubmit={this.Submit}   
                   isComplete={complete} 
                   />);
    },
    isComplete() {
        if (this.props.Survey.Pages === null) return false;

        const allValid = this.props.Survey.Pages.every(
            QuestionValidationStatus.PageIsPositivelyValid);

        return allValid;
    }, 
    BackToSurvey() {
        Navigator.OpenSurvey(
            this.props.Survey.Type, this.props.Survey.FacilityNumber, this.props.Survey.GUID);
    },
    Submit() {
        auditCompletionDispatchers.Submit(
            this.props.Survey.Type, this.props.Survey.FacilityNumber, this.props.Survey.GUID);
    }
});



module.exports = SurveyConfirmation;


// WEBPACK FOOTER //
// ./src/components/SurveyConfirmation/SurveyConfirmation.jsx